import { z } from 'zod'

import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetEquipmentRefResponseSchema = z.array(
  z.object({
    id: numberOrStringToNumberSchema,
    name: z.string(),
    category: z.string(),
    group: z.boolean(),
  }),
)

export type GetEquipmentRefResponse = z.infer<typeof GetEquipmentRefResponseSchema>
